/* Reconcile playback after the theme's Flickity handlers, on mobile only. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const mounted = new WeakSet();

  function mount(root) {
    if (mounted.has(root)) return;
    mounted.add(root);

    function sync() {
      if (!mobile.matches || document.hidden || !root.isConnected) return;
      const slides = [...root.querySelectorAll('.slide-item')];
      const selected = slides.find(slide => slide.classList.contains('is-selected')) || slides[0];
      for (const slide of slides) {
        const video = slide.querySelector('video');
        if (!video) continue;
        if (slide !== selected) {
          video.pause();
          continue;
        }
        if (!video.autoplay) continue;
        video.muted = true;
        video.playsInline = true;
        if (video.ended) video.currentTime = 0;
        const playing = video.play();
        if (playing) playing.catch(() => { /* Browser may still require a gesture. */ });
      }
    }

    const observer = new MutationObserver(records => {
      if (!root.isConnected) {
        observer.disconnect();
        return;
      }
      if (records.some(record => record.target.matches('.slide-item'))) sync();
    });
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
    root.addEventListener('touchend', sync, { passive: true });
    document.addEventListener('visibilitychange', sync);
    mobile.addEventListener('change', sync);
    document.addEventListener('shopify:section:unload', function unload(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      document.removeEventListener('visibilitychange', sync);
      mobile.removeEventListener('change', sync);
      document.removeEventListener('shopify:section:unload', unload);
    });
    sync();
  }

  function init() {
    document.querySelectorAll('.mobile-home-hero').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
